import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export default function InvitePage() {
  const { token } = useParams();

  useEffect(() => {
    if (!token) return;

    const deepLink = `scala-app://register/${token}`;

    window.location.href = deepLink;

    const timeout = setTimeout(() => {
      const ua = navigator.userAgent.toLowerCase();

      if (ua.includes('android')) {
        window.location.href =
          'https://play.google.com/store/apps/details?id=com.project.scala.app';
      } else {
        window.location.href =
          'https://apps.apple.com/br/app/geoescala/id6758113248';
      }
    }, 3500);

    return () => clearTimeout(timeout);
  }, [token]);

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Open Sans, sans-serif',
      }}
    >
      <p>Tentando abrir o Geoescala App…</p>
    </div>
  );
}
